module.exports = __webpack_public_path__ + "img/sunlei-500x500.bac6fd36.jpg";